import { ReactNode } from "react";

interface TermsConditionsParagraphProps {
    text: string
}

const TermsConditionsSectionParagraph = (props: TermsConditionsParagraphProps) => {

    const { text } = props;

    return (
        <>
            <br />
            <p className="font-semibold">{text}</p>
        </>
    )
}


interface TermsConditionsSectionProps {
    title: string,
    children: ReactNode
}

const TermsConditionsSection = (props: TermsConditionsSectionProps) => {

    const { title, children } = props;

    return (
        <div className="flex flex-col my-1 max-w-3xl">
            <h2 className="font-bold text-xl text-[#93885B]">{title}</h2>
            { children }
            <br />
        </div>
    )
}

TermsConditionsSection.Paragraph = TermsConditionsSectionParagraph;

export default TermsConditionsSection;